import React, { useState } from "react";
import { FaMinus, FaPlus, FaUserCog, FaFileInvoiceDollar, FaClipboardCheck, FaUserCheck, FaMoneyCheckAlt } from "react-icons/fa";
import { AiOutlineApi, AiOutlineSafetyCertificate, AiOutlineAppstore } from "react-icons/ai";
import { MdSecurity, MdIntegrationInstructions, MdReceiptLong, MdVerifiedUser, MdAssessment, MdMonetizationOn, MdGavel, MdSyncAlt, MdWorkspaces } from "react-icons/md";
import { FaUsersCog, FaUserShield, FaHandshake, FaRegLightbulb, FaRegCheckCircle } from "react-icons/fa";
import Medpalm from "../../../assests/Healthsoftware/rcm.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
  {
    "title": "Medical Billing Specialist",
    "description": "Our Medical Billing Specialists handle the entire billing process, from patient charge entry to insurance claims submission, ensuring accurate and timely payments."
  },
  {
    "title": "Medical Coder",
    "description": "Assigns standardized medical codes (ICD-10, CPT, HCPCS) to diagnoses, procedures, and treatments based on patient medical records. Ensures accurate documentation of healthcare services to facilitate insurance claims processing, regulatory compliance, and medical data reporting. Works closely with physicians and billing teams to minimize claim rejections, improve reimbursement rates, and uphold industry coding standards. Their role is crucial in maintaining the integrity and accuracy of clinical documentation."
  },
  {
    "title": "Revenue Integrity Analyst",
    "description": "Monitors and audits medical billing and coding processes to ensure compliance with healthcare regulations, insurance payer policies, and revenue cycle best practices. Identifies discrepancies, prevents fraudulent claims, and implements process improvements to enhance financial performance. Analyzes revenue cycle data to detect trends, reduce revenue leakage, and optimize billing efficiency while maintaining transparency and ethical billing practices."
  },
  {
    "title": "Insurance Verification Specialist",
    "description": "Verifies patients' insurance coverage, eligibility, and benefits before medical procedures or treatments. Communicates with insurance providers to determine co-pays, deductibles, and pre-authorization requirements. By proactively addressing coverage issues, they prevent claim denials, reduce financial surprises for patients, and ensure a smoother billing process. Their role enhances both operational efficiency and patient satisfaction by clarifying financial responsibilities upfront."
  },
  // {
  //   "title": "Patient Financial Counselor",
  //   "description": "Assists patients in understanding their medical bills, insurance benefits, and available financial assistance programs. Works with individuals facing financial hardships, helping them apply for financial aid, set up flexible payment plans, and resolve insurance disputes. Ensures that patients receive necessary medical care without excessive financial strain, improving patient satisfaction and reducing unpaid medical debt for healthcare facilities."
  // },
  {
    "title": "RCM (Revenue Cycle Management) Manager",
    "description": "Oversees the entire revenue cycle process, from patient registration and charge capture to coding, billing, claims processing, and reimbursement. Analyzes financial reports, implements cost-saving measures, and ensures compliance with federal and state healthcare regulations. Develops strategies to reduce claim denials, improve cash flow, and enhance operational efficiency within healthcare revenue operations. Their leadership ensures the financial stability of healthcare organizations while maintaining a patient-centered approach."
  }
]

const features = [
  { text: "Automated Billing and Collections-Streamline billing and collections using automated systems to improve accuracy and reduce delays", icon: <MdReceiptLong className="text-[#2a627a] text-xl" /> },
  { text: "Integrated Billing & Coding Solutions- We integrate billing and coding systems with clinical systems, ensuring data consistency and improved workflow efficiency.", icon: <MdIntegrationInstructions className="text-[#2a627a] text-xl" /> },
  { text: "Patient Eligibility Verification- Our solutions help verify patient eligibility and reduce claim denials, ensuring smoother billing processes.", icon: <MdVerifiedUser className="text-[#2a627a] text-xl" /> },
  { text: "Comprehensive Reporting- We provide advanced reporting capabilities for transparency, analysis, and performance tracking across the revenue cycle.", icon: <MdAssessment className="text-[#2a627a] text-xl" /> },
  // { text: "Customizable reporting for financial insights.", icon: <FaUsersCog className="text-[#2a627a] text-xl" /> },
  // { text: "HIPAA-compliant patient data security.", icon: <MdIntegrationInstructions className="text-[#2a627a] text-xl" /> }
];

const benefits = [
  { text: "Increased Revenue - By streamlining the billing and coding process, we help improve the collection of payments and reduce revenue leakage.", icon: <MdMonetizationOn className="text-[#2a627a] text-xl" /> },
  { text: "Reduced Claim Denials - Our solutions ensure accurate insurance verification and billing, minimizing claim rejections and delays.", icon: <MdGavel className="text-[#2a627a] text-xl" /> },
  { text: "Improved Cash Flow - We help optimize the revenue cycle, ensuring quicker reimbursement and improved cash flow for healthcare organizations.", icon: <MdSyncAlt className="text-[#2a627a] text-xl" /> },
  // { text: "Increases transparency in financial transactions.", icon: <MdSecurity className="text-[#2a627a] text-xl" /> },
  { text: "Enhanced Compliance - We ensure full compliance with regulatory requirements such as HIPAA, reducing the risk of penalties and legal issues.", icon: <MdVerifiedUser className="text-[#2a627a] text-xl" /> },
  { text: "Efficient Operations - Our solutions streamline administrative processes, freeing up valuable resources for patient care.", icon: <MdWorkspaces className="text-[#2a627a] text-xl" /> }
];
const cmsFeatures = [
  { icon: <FaUserCog className="text-[#2a627a] text-xl" />, text: "RCM Manager – Our RCM managers oversee and optimize the entire revenue cycle process, ensuring efficient operations and improved revenue realization." },
  { icon: <FaFileInvoiceDollar className="text-[#2a627a] text-xl" />, text: "Medical Biller – We help manage the billing process, ensuring timely and accurate submissions to insurance providers and patients." },
  { icon: <FaClipboardCheck className="text-[#2a627a] text-xl" />, text: "Medical Coder – We ensure accurate and consistent medical coding for diagnosis and procedures to ensure proper billing and reimbursement." },
  { icon: <FaUserShield className="text-[#2a627a] text-xl" />, text: "Revenue Integrity Analyst – We maintain revenue integrity by minimizing errors, ensuring compliance, and optimizing reimbursement cycles." },
  { icon: <FaUserCheck className="text-[#2a627a] text-xl" />, text: "Insurance Verification Specialist – We verify patient insurance coverage to ensure eligibility and reduce payment delays." },
  { icon: <FaMoneyCheckAlt className="text-[#2a627a] text-xl" />, text: "Patient Financial Counselor – We help patients understand their financial responsibility and work with them to manage payment options and payment plans." }
];

const RCM = () => {
  const [openIndex, setOpenIndex] = useState(0);
  return (
    <>
      <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
        {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
        {/* Header Section */}
        <div className=" text-center w-full">
          <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  flex justify-center items-center">Revenue Cycle Management- <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
          <p className="text-gray-800 mt-3 text-sm">
            Optimizing financial processes to enhance healthcare efficiency and revenue collection.
          </p>
        </div>

        {/* What is RCM? */}
        <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
          <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
          <div className="md:ml-6 mt-2 md:mt-0">
            <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Revenue Cycle Management?</h2>
            <p className="text-gray-800 mt-2 text-sm text-wrap">
              Revenue Cycle Management (RCM) involves the management of financial transactions and patient billing from the moment a patient schedules an appointment to the final payment for medical services. We help streamline this process, ensuring accurate coding, billing, insurance verification, and collections.
            </p>
          </div>
        </section>

        {/* Role in RCM*/}
        <section className="mt-8 w-full">
          <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
            Role in RCM
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
            {cmsFeatures.map((item, index) => (
              <motion.div
                key={index}
                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                <span className="text-sm">{item.icon}</span>
                <span className="text-gray-700 text-[14px] font-medium">{item.text}</span>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Key Features Section */}
        <section className="mt-6 w-full">
          <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
            Key Features
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
            {features.map((item, index) => (
              <motion.div
                key={index}
                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                whileInView={{ opacity: 1, x: 0 }} // Move to center
                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                <span className="text-xl">{item.icon}</span>
                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
              </motion.div>
            ))}
          </div>
        </section>


        {/* Benefits Section */}
        <section className="mt-8 w-full">
          <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
            Benefits
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
            {benefits.map((item, index) => (
              <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                viewport={{ once: false, amount: 0.3 }}>

                <span className="text-xl">{item.icon}</span>
                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
              </motion.div>
            ))}
          </div>
        </section>




        {/* Services Section */}
        <section className="mt-12 w-full  mx-auto">
          {/* Heading */}
          <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
            Discover Our Services
          </h2>

          {/* Service List */}
          <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
            {services.map((service, index) => (
              <div key={index} className="border-b border-gray-800">
                {/* Service Title */}
                <button
                  className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                  onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                >
                  {service.title}
                  {openIndex === index ? (
                    <FaMinus className="text-red-500" />
                  ) : (
                    <FaPlus className="text-gray-600" />
                  )}
                </button>

                {/* Service Description (Expandable with Animation) */}
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                  className="overflow-hidden"
                >
                  <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                </motion.div>
              </div>
            ))}
          </div>
        </section>

      </div>
      <Footer />
    </>
  );
};

export default RCM;
